export default __webpack_public_path__ + "static/media/Eye_2_M_C2.b40220b6.svg";